
import algoliasearch from 'algoliasearch/lite'
import {
  AisAutocomplete,
  AisConfigure,
  AisHighlight,
  AisInstantSearch,
} from 'vue-instantsearch'
import { Component, Prop, Vue } from 'vue-property-decorator'

const HITS_PER_PAGE = 10

@Component({
  components: {
    AisAutocomplete,
    AisConfigure,
    AisHighlight,
    AisInstantSearch,
  },
})
export default class AlgoliaSearch extends Vue {
  @Prop()
    categories: number[]

  searchClient = algoliasearch(
    this.$config.public.algoliaAppId,
    this.$config.public.algoliaApiKey,
  )

  get searchConfigure() {
    return {
      highlightPreTag: '<mark>',
      highlightPostTag: '</mark>',
      hitsPerPage: HITS_PER_PAGE,
      filters: this.categories
        ? this.categories.map((c) => `categories=${c}`).join(' OR ')
        : '',
    }
  }

  get indexName() {
    const locale = this.$i18n.localeInfo.code
    return `${this.$config.public.algoliaIndexPrefix}faq_${locale}`
  }
}
